import { render, staticRenderFns } from "./EvaluationQuestionsSlide.vue?vue&type=template&id=f2ba23fc"
import script from "./EvaluationQuestionsSlide.vue?vue&type=script&lang=js"
export * from "./EvaluationQuestionsSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2ba23fc')) {
      api.createRecord('f2ba23fc', component.options)
    } else {
      api.reload('f2ba23fc', component.options)
    }
    module.hot.accept("./EvaluationQuestionsSlide.vue?vue&type=template&id=f2ba23fc", function () {
      api.rerender('f2ba23fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/slides/EvaluationQuestionsSlide.vue"
export default component.exports